"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.array.index-of.js");
var _icon = _interopRequireDefault(require("../icon"));
var _info = _interopRequireDefault(require("../info"));
var COMPONENT_NAME = 'z-checker-item';
var _default2 = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('li', {
      staticClass: "z-checker-item",
      class: {
        'z-checker-item_white': _vm.whiteBackground,
        'z-checker-item_square': _vm.border === 'square',
        'z-checker-item_round': _vm.border === 'round',
        'z-checker-item_outlined': _vm.outlined,
        'z-checker-item_active': _vm.isActive,
        'z-checker-item_fixed-width': _vm.width,
        'z-checker-item_disabled': _vm.option.disabled,
        'z-checker-item_with-sub-text': _vm.option[_vm.$parent.subTextKey || 'subText'],
        'z-checker-item_line-clamp-1': +_vm.lineClamp === 1,
        'z-checker-item_line-clamp-2': _vm.isLineClamp2,
        'z-checker-item_line-clamp-2-small': _vm.isLineClamp2Small,
        'z-checker-item_big': _vm.isBig
      },
      style: _vm.style,
      on: {
        "click": _vm.clickHandler
      }
    }, [_vm._t("default", [_vm.option.icon ? _c('z-icon', {
      staticClass: "z-checker-item_icon",
      attrs: {
        "class-prefix": _vm.option.classPrefix || (_vm.option.zziconfont ? 'zziconfont' : undefined),
        "name": _vm.option.icon,
        "size": "20px"
      }
    }) : _vm._e(), _c('span', {
      ref: "itemText",
      staticClass: "z-checker-item-text",
      domProps: {
        "innerHTML": _vm._s(_vm.option[_vm.$parent.textKey || 'text'])
      }
    }), _vm.option[_vm.$parent.subTextKey || 'subText'] ? _c('span', {
      staticClass: "z-checker-item_sub-text",
      domProps: {
        "innerHTML": _vm._s(_vm.option[_vm.$parent.subTextKey || 'subText'])
      }
    }) : _vm._e(), _vm.isBig ? _c('span', {
      staticClass: "z-checker-item_big__select"
    }, [_c('svg', {
      staticClass: "icon",
      attrs: {
        "t": "1662462542052",
        "viewBox": "0 0 1024 1024",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "p-id": "1490",
        "width": "8",
        "height": "8"
      }
    }, [_c('path', {
      attrs: {
        "d": "M82.260096 451.648212a96 96 0 0 1 135.764502 0l158.527684 158.527684L806.201676 180.526502a96 96 0 0 1 135.764502 135.764502l-497.803174 497.803174a96 96 0 0 1-135.764502 0l-6.199912-6.83348L82.305351 587.367459a96 96 0 0 1 0-135.764502z",
        "p-id": "1491",
        "fill": "#ffffff"
      }
    })])]) : _vm._e()]), _vm.isBig && _vm.slotKeepBig ? _c('span', {
      staticClass: "z-checker-item_big__select"
    }, [_c('svg', {
      staticClass: "icon",
      attrs: {
        "t": "1662462542052",
        "viewBox": "0 0 1024 1024",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "p-id": "1490",
        "width": "8",
        "height": "8"
      }
    }, [_c('path', {
      attrs: {
        "d": "M82.260096 451.648212a96 96 0 0 1 135.764502 0l158.527684 158.527684L806.201676 180.526502a96 96 0 0 1 135.764502 135.764502l-497.803174 497.803174a96 96 0 0 1-135.764502 0l-6.199912-6.83348L82.305351 587.367459a96 96 0 0 1 0-135.764502z",
        "p-id": "1491",
        "fill": "#ffffff"
      }
    })])]) : _vm._e(), _vm.option.info ? _c('z-info', {
      attrs: {
        "info": _vm.option.info,
        "type": "text"
      }
    }) : _vm._e()], 2);
  },
  name: COMPONENT_NAME,
  components: {
    'z-icon': _icon.default,
    'z-info': _info.default
  },
  props: {
    option: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    active: Boolean,
    // 隐藏属性，不与父组件一起使用时生效
    border: {
      type: String,
      default: 'square' // 可选  round
    },

    outlined: {
      type: Boolean,
      default: false
    },
    width: [Number, String],
    lineClamp: [Number, String],
    whiteBackground: Boolean,
    isBig: {
      type: Boolean,
      default: false
    },
    slotKeepBig: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isLineClamp2Small: false
    };
  },
  computed: {
    style: function style() {
      var width = typeof this.width === 'number' ? this.width + 'px' : this.width;
      return {
        width: width
      };
    },
    isLineClamp2: function isLineClamp2() {
      return +this.lineClamp === 2 && !this.option[this.$parent.subTextKey || 'subText'];
    },
    isActive: function isActive() {
      if (this.$parent && Object.prototype.hasOwnProperty.call(this.$parent, 'currentValue') && !this.outlined) {
        var currentValue = this.$parent.currentValue;
        var isRadio = this.$parent.isRadio;
        var value = this.option[this.$parent.valueKey || 'value'];
        return isRadio ? currentValue === value : (currentValue === null || currentValue === void 0 ? void 0 : currentValue.indexOf(value)) >= 0;
      }
      return this.active;
    }
  },
  watch: {
    isActive: function isActive(val) {
      this.$emit('change', val);
    }
  },
  mounted: function mounted() {
    // 确保设置显示两行的标签，只在真正显示两行的时候才启用小字体
    if (this.isLineClamp2) {
      var _text, _this$$el;
      var text;
      if (this.$slots.default) {
        try {
          text = this.$slots.default[0].elm;
        } catch (e) {
          // console.log(e)
        }
      } else {
        text = this.$refs.itemText;
      }
      if (((_text = text) === null || _text === void 0 ? void 0 : _text.offsetHeight) > ((_this$$el = this.$el) === null || _this$$el === void 0 ? void 0 : _this$$el.offsetHeight)) {
        this.isLineClamp2Small = true;
      }
    }
  },
  methods: {
    clickHandler: function clickHandler(event) {
      if (!this.option.disabled) {
        if (this.$parent && typeof this.$parent.check === 'function') {
          this.$parent.check(this.option);
        }
        this.$emit('click', event);
      }
    }
  }
};
exports.default = _default2;